import {
  CreateTaskFileDocument,
  CreateTaskFileMutationVariables,
  GetTaskFilesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateTaskFile = () => {
  const [createTaskFile, { loading }] = useMutation(CreateTaskFileDocument, {
    extractorFn: (data) => data.tasksMutations.createTasksTaskFile,
    refetchQueries: [GetTaskFilesDocument],
  })

  return {
    createTaskFile: (variables: CreateTaskFileMutationVariables) => {
      return createTaskFile({
        variables,
      })
    },
    loading,
  }
}
